import React from "react";
import {Drawer, Form, Button, Col, Row, Input, Select} from 'antd';
import {
    findRecordKeyField2,
    GetRecordDisplayName,
    LoadDataAnyEndpoint,
    SortData,
    SubmitLogInformation
} from "../../../api/fn";
import moment from "moment";
import {GetUserToken} from "../../../api/token";
import {fetchDataEntity} from "../../../api/entity-data";


const {Option} = Select;

const findEntityFields=(entity,org,project,_this)=>{
    let fields = _this.state.Fields;
    let ls=[];
    for(let i in fields){
        let row=fields[i];
        if(org!==row.org){
            continue
        }
        if(project!==row.module){
            continue
        }
        if("entity"!==row.category){
            continue
        }
        if(entity!==row.ref){
            continue
        }
        ls.push(row)
    }
    return ls;
}

const linkEntityOptions=(entity,rowIn,_this)=>{
    let informations = _this.state.Informations;
    let ls={};
    let attributes = findEntityFields(entity,rowIn.org,rowIn.module,_this);
    console.log("linkEntityOptions > ",rowIn," > ",informations);
    for(let i in informations){
        let row=informations[i];
        if(rowIn.org!==row.org){
            continue
        }
        if(rowIn.module!==row.project){
            continue
        }
        if(row.action!=="entity"){
            continue
        }
        console.log("linkEntityOptions 2 > ",row);
        if(row.category!==entity){
            continue
        }

        let name =  GetRecordDisplayName(row.org,row.project,row,attributes,"displaydelection");

        ls[row.ref]=name;
    }
    return ls;

}

const makeCol = (row, _this,parent) => {
    let { handleChangeInput} = _this;
    if (row === null) {
        return null;
    }
    if (row.datatype === "list") {
        let options = [];
        let definedOptions = row.options;
        if(row.linkentity!==""){
            definedOptions =linkEntityOptions(row.linkentity,row,parent)
        }
        for (let i in definedOptions) {
            const key = i;
            const val = i;
            options.push({
                key: key,
                val: val,
            })
        }
        return (
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.fieldname}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <Select
                        placeholder={"Please enter user " + row.fieldname}
                        onChange={(e) => handleChangeInput(e, row.fieldname)}
                    >
                        {options.map(rec => {
                            return (
                                <Option value={rec.key}>{rec.val}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            </Col>
        )
    }
    return (
        <Col span={12}>
            <Form.Item
                name={row.fieldname}
                label={row.fieldname}
                rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
            >
                <Input
                    placeholder={"Please enter user " + row.fieldname}
                    onChange={(e) => handleChangeInput(e.target.value, row.fieldname)}
                />
            </Form.Item>
        </Col>
    )
}

export default class NewEntityDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            selectedEntity:"",
            newEntry:{},
        }
    }

    handleChange = async (e, key) => {
        const value = e.value;
        this.setState({
            [key]: value,
        });

    }
    handleChangeInput=(val,key)=>{
        let tmp=this.state;
        tmp.newEntry[key]=val;
        this.setState(tmp);
    }
    validateSubmitINput=()=>{
        let attributes=this.getAttributes();
        let newEntry = this.state.newEntry;
        for(let i in attributes){
            const row = attributes[i];
            if(row.mandatory){
                if(typeof newEntry[row.fieldname]==="undefined"){
                    alert("Sorry "+row.fieldname+" is required field and can't be empty!");
                    return false;
                }
                if(newEntry[row.fieldname]===""){
                    alert("Sorry "+row.fieldname+" is required field and can't be empty!");
                    return false;
                }
            }
        }
        return true;
    }

    onSubmit=async ()=>{
        if(!this.validateSubmitINput()){
            return
        }
        let self=this;

        if (!window.confirm("Are you sure to submit this record!")) {
            return
        }

        let {_this } = this.props;
        let {state, handleChangeInput, handleChangeInput2} = _this;
        let data = state.selectedRecord;

        let org = state.selectedCompany;
        let project =state.selectedProject;
        let entity =state.selectedEntity;

        let fieldsList = _this.getAttributes();


        let o = {};
        for (let i in fieldsList) {
            const row = fieldsList[i];
            const key = row.fieldname;
            let val = this.state.newEntry[key];
            const type =row.datatype;
            if (type === "float") {
                //val = parseFloat(val)
            } else if (type === "number") {
                //val = parseInt(val)
            } else if (type === "boolean") {
                val = val === "yes"
            } else {
                //todo do nothing
            }
            o[key] = val;
        }

        let workDate = moment().format("YYYY-MM-DD");
        let userInfo = GetUserToken();
        let username  = userInfo.Username;

        let inData = {data:o}
        let names = GetRecordDisplayName(org,project,inData,fieldsList,"displaydelection");
        let uniqueKeyField = findRecordKeyField2(fieldsList, "unique");
        let uniqueValue = "";
        if(typeof o[uniqueKeyField]!=="undefined"){
            uniqueValue = o[uniqueKeyField];
        }


        let hub = {
            Org: org,
            project: project,
            Data: o,
            Ref: uniqueValue,
            Action:"entity",
            Category:entity,
            Name:names,
            WorkDate:workDate,
            Username:username,
        }


        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = {}
        let endpoint = "/common/entity/Informations/insert"; // "/manager/entity/insert/extensions";

        console.log("onSubmit new stage send 2 > ", post);

        await LoadDataAnyEndpoint(post, endpoint, "Data", this,async (dataOut) => {
            console.log("onSubmit new stage response > ", dataOut);
            self.onClose();
            _this.setState({
                newEntry:{},
            });
            await fetchDataEntity("Informations", "", "", _this, undefined, "common/entity/Informations/list");
            //await SubmitLogInformation(org,project,"actsivity","all",self.state.selectedActivity,data.record.ref,o,self)
            alert("Thank you record added!")

        });

    }

    getAttributes=()=>{
        let ls=[];
        let {_this } = this.props;
        let {state} = _this;
        let data = state.selectedRecord;
        if(data===null){return ls}

        ls = _this.getAttributes();
        ls = SortData("position",ls)
        return ls;

       /* if(typeof data.record ==="undefined"){return ls}
        let org = data.record.org;
        let project = data.record.module;

        console.log("New Stage GetAtt> ",data);

        for(let  i in state.Fields){
            let row = state.Fields[i];
            if(row.org!==org){continue}
            if(row.module!==project){continue}
            if(row.category!=="stage"){continue}
            if(row.ref!==this.state.selectedStage){continue}
            ls.push(row);
        }
        return ls*/

    }
    getTitle=()=>{
        let {_this } = this.props;
        let {state} = _this;
        if(state.selectedRecord!==null){
            return state.selectedEntity;
        }
        return "----"
    }
    onClose=()=>{
        let {_this } = this.props;
        _this.setState({
            showDrawer:false,
            selectedRecord:null
        })
    }


    render() {
        let {_this } = this.props;
        let {state} = _this;
        let attributes = this.getAttributes()

        let ls = [];
        let loopIndex = 0;
        for (let i = 0; i < attributes.length; i += 2) {
            loopIndex = i;
            const row = attributes[i];
            let row2 = null;
            let nextIndex = i + 1;
            if (nextIndex < (attributes.length)) {
                row2 = attributes[nextIndex]
            }
            ls.push(
                <Row gutter={16}>
                    {makeCol(row, this,_this)}
                    {makeCol(row2, this,_this)}
                </Row>
            );
            console.log("Loop ::::--> ", i, " > ", row.fieldname)
        }

        return (
            <>
                <Drawer
                    title={"Create new entity for :"+this.getTitle()}
                    width={720}
                    onClose={this.onClose}
                    visible={state.showDrawer}
                    bodyStyle={{paddingBottom: 80}}
                    footer={
                        <div
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <Button onClick={this.onClose} style={{marginRight: 8}}>
                                Cancel
                            </Button>
                            <Button onClick={this.onSubmit} type="primary">
                                Submit
                            </Button>
                        </div>
                    }
                >

                    <Form layout="vertical" hideRequiredMark>
                        {ls.map(row => {
                            return row;
                        })}

                    </Form>
                </Drawer>
            </>
        )
    }
}
